import { useEffect, useRef } from 'react';
import { PublicBannerSection } from '../../components/banners/PublicBannerSection';
import { PublicBannerSkeleton } from '../../components/banners/PublicBannerSkeleton';
import { FREE_TOOLS_PAGE } from '../../components/error-boundary/ErrorBoundaryNames';
import { PublicFaqsSection } from '../../components/faqs/PublicFaqsSection';
import { LoadablePublicProductFeatureTable } from '../../components/feature-table/PublicProductFeatureTable.loadable';
import { PublicHubPageHeader } from '../../components/header/PublicHubPageHeader';
import { LoadablePublicHubCreditsExplainer } from '../../components/hub-credits-explainer/PublicHubCreditsExplainer.loadable';
import { PublicHubMerchCards } from '../../components/merch-card/PublicHubMerchCards';
import { PublicComparePlansLink } from '../../components/PublicComparePlansLink';
import { PublicPageWrapper } from '../../components/PublicPageWrapper';
import PublicPhoneSupportMiddle from '../../components/PublicPhoneSupportMiddle';
import { usePublicBannerForPage } from '../../hooks/usePublicBannerForPage';
import { usePublicDocumentTitle } from '../../hooks/usePublicDocumentTitle';
import { usePublicPageUrlState } from '../../hooks/usePublicPageUrlState';
import { usePublicProductGroupsData } from '../../hooks/usePublicProductGroupsData';
import { Screens } from '../../types/PublicNavItem';
import { trackClickedLink, trackPageView } from '../../utils/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PRODUCT_GROUP = 'FREE';
const SCREEN = Screens.FREE;
export default function PublicFreeToolsPage() {
  const {
    selectedTerm,
    setSelectedTerm
  } = usePublicPageUrlState();
  const {
    rawData,
    cards,
    cardCount,
    status,
    currencyCode,
    starterApiName
  } = usePublicProductGroupsData(PRODUCT_GROUP, {
    selectedTerm,
    isEnterpriseTier: false
  });
  const {
    hasBanner,
    bannerProps
  } = usePublicBannerForPage(rawData, SCREEN);
  usePublicDocumentTitle(SCREEN);
  const hasTrackedPageViewRef = useRef(false);
  useEffect(() => {
    if (!hasTrackedPageViewRef.current) {
      hasTrackedPageViewRef.current = true;
      trackPageView({
        screen: SCREEN
      });
    }
  }, []);
  return /*#__PURE__*/_jsxs(PublicPageWrapper, {
    errorBoundaryName: FREE_TOOLS_PAGE,
    navMarkerName: "FREE_TOOLS_PAGE_V2",
    metricsRoute: SCREEN,
    chunkName: "public-free-tools-page",
    children: [/*#__PURE__*/_jsx(PublicBannerSkeleton, {
      isLoading: status === 'loading',
      children: hasBanner && /*#__PURE__*/_jsx(PublicBannerSection, Object.assign({}, bannerProps))
    }), /*#__PURE__*/_jsx(PublicHubPageHeader, {
      productGroup: PRODUCT_GROUP
    }), /*#__PURE__*/_jsx(PublicHubMerchCards, {
      cards: cards,
      productGroup: PRODUCT_GROUP,
      status: status,
      currencyCode: currencyCode,
      selectedTerm: selectedTerm,
      setSelectedTerm: setSelectedTerm,
      skeletonCount: cardCount,
      screen: SCREEN
    }), /*#__PURE__*/_jsx(LoadablePublicHubCreditsExplainer, {
      screen: SCREEN,
      cards: cards,
      currencyCode: currencyCode,
      term: selectedTerm,
      starterApiName: starterApiName
    }), /*#__PURE__*/_jsx(PublicComparePlansLink, {
      onClick: () => trackClickedLink({
        name: 'compare-plans',
        url: '#feature-table',
        type: 'internal',
        trackingSource: SCREEN,
        screen: SCREEN
      })
    }), /*#__PURE__*/_jsx(LoadablePublicProductFeatureTable, {
      productGroup: PRODUCT_GROUP,
      productGroupResponse: rawData,
      currencyCode: currencyCode,
      selectedTerm: selectedTerm,
      screen: SCREEN
    }), /*#__PURE__*/_jsx(PublicPhoneSupportMiddle, {}), /*#__PURE__*/_jsx(PublicFaqsSection, {
      productGroup: PRODUCT_GROUP,
      screen: SCREEN
    })]
  });
}